import { render, staticRenderFns } from "./AdminPanelYoutvShoppingPacket.vue?vue&type=template&id=936a1db6&"
import script from "./AdminPanelYoutvShoppingPacket.vue?vue&type=script&lang=js&"
export * from "./AdminPanelYoutvShoppingPacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports